export function progress(state){
    return state.progress
}

export function search(state){
    return state.search
}

export function selected_areas(state){
    return state.selected_areas
}

export function webinar_status(state){
    return state.webinar_status
}

export function webinar_is_online(state){
    return state.webinar_is_online
}

export function selected_groups(state){
    return state.selected_groups
}

export function selected_tags(state){
    return state.selected_tags
}

export function webcast_lounge_template( state) {
    return state.webcast_lounge_template
}

export function loading(state){
    return state.loading
}